import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ReconnectChannelRequest, ReconnectChannelResult } from '@troia-v3/types';
import { channelsApi } from '../services';

/**
 * Hook para reconectar canal e obter novo QR Code.
 *
 * Aceita `{ id, body? }` — sem body = comportamento legado (gateway QR).
 * Com `body.credentials` = renovação de token de provider oficial.
 *
 * @example
 * const reconnect = useReconnectChannel();
 *
 * const handleReconnect = async () => {
 *   const result = await reconnect.mutateAsync({ id: channelId });
 *   if (result.qrCode) {
 *     // Exibir QR Code
 *   }
 * };
 */
export const useReconnectChannel = () => {
  const queryClient = useQueryClient();

  return useMutation<ReconnectChannelResult, Error, { id: string; body?: ReconnectChannelRequest }>({
    mutationFn: ({ id, body }) => channelsApi.reconnect(id, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['channels'] });
    },
  });
};
